"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeUpCss = makeUpCss;
var styles = {
  'yl-array-object': '.arrayObjectActive{ border:1px solid #00a697}'
};
function addCss(cssList, el) {
  var css = typeof styles[el.__config__.tag] == 'function' ? styles[el.__config__.tag](el) : styles[el.__config__.tag];
  css && cssList.indexOf(css) === -1 && cssList.push(css);
  if (el.__config__.children) {
    el.__config__.children.forEach(function (el2) {
      return addCss(cssList, el2);
    });
  }
}
function makeUpCss(componentList) {
  var cssList = [];
  componentList.forEach(function (el) {
    return addCss(cssList, el);
  });
  return cssList.join('\n');
}